import { gql } from '@apollo/client';

export const DELETE_NECROLOGIO = gql`
  mutation deleteNecrologio($id: ID!) {
    deleteAnnunci_funebri(input: { id: $id }) {
      annunci_funebri {
        objectId
      }
    }
  }
`;

export const FETCH_ANNUNCIO_FUNEBRE = gql`
  query fetchAnnuncioFunebre($defuntoId: ID!, $tipo: String!) {
    annunci_funebris(
      where: {
        defunto_pointer: { have: { objectId: { equalTo: $defuntoId } } }
        tipo: { equalTo: $tipo }
      }
      first: 1
    ) {
      edges {
        node {
          objectId
          defunto_pointer {
            objectId
          }
          tipo
          pubblicato
          comune
          link_annuncifunebri
          link_cliente
          visibile
          sms_famiglia
          mail_famiglia
          data_morte
          nome_chiesa
          indirizzo_chiesa
          citta_chiesa
          nome_cimitero
          data_funerale
          nome
          cognome
          foto {
            name
            url
          }
          updatedAt
          createdAt
        }
      }
    }
  }
`;

export const CREATE_ANNUNCIO_FUNEBRE = gql`
  mutation createAnnuncioFunebre($fields: CreateAnnunci_funebriFieldsInput) {
    createAnnunci_funebri(input: { fields: $fields }) {
      annunci_funebri {
        objectId
      }
    }
  }
`;

export const UPDATE_ANNUNCIO_FUNEBRE = gql`
  mutation updateAnnuncioFunebre(
    $id: ID!
    $fields: UpdateAnnunci_funebriFieldsInput
  ) {
    updateAnnunci_funebri(input: { id: $id, fields: $fields }) {
      annunci_funebri {
        objectId
      }
    }
  }
`;
